import { render, staticRenderFns } from "./quojiang.vue?vue&type=template&id=2be3f92b&scoped=true&"
import script from "./quojiang.vue?vue&type=script&lang=js&"
export * from "./quojiang.vue?vue&type=script&lang=js&"
import style0 from "./quojiang.vue?vue&type=style&index=0&id=2be3f92b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be3f92b",
  null
  
)

export default component.exports